<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">Notification</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<!-- Slack -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-slack.png" alt="Slack">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="isShowModalSlack = true" v-if="slackAccounts.length === 0">+ Add Slack Account</button>
							</div>
						</div>
						<integration-accounts
							:name="'Slack Accounts'"
							:accounts="slackAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
					<!-- Email -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="text">Email Account</div>
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="isShowModalEmail = true">+ Add Email Account</button>
							</div>
						</div>
						<div class="integration-warning">
							Daftar email berikut adalah daftar email yang dapat digunakan untuk mendapatkan notifikasi jika terjadi pemesanan,<br>
							Silahkan ikuti tutorial <a href="https://help.ostock.id/id/articles/6926096-section-setting-web" target="_blank">https://help.ostock.id/mengatur-notifikasi/</a> untuk mengatur notifikasi pada masing-masing produk Anda.<br>
						</div>
						<integration-accounts
							:name="'Email Accounts'"
							:accounts="emailAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Slack -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalSlack" @close="isShowModalSlack = false">
			<div slot="header"><h3>Slack</h3></div>
			<div slot="body" class="text-center">
				<h4 class="modal-title">How to Integrate</h4>
				<div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/vE7yKQVd-a4?rel=0"></iframe>
				</div>
				<div class="integration-actions">
					<a :href="slackUrl"><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>
					<!-- <button class="btn btn-primary btn-lg">Connect Slack</button> -->
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalSlack = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- Email -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalEmail" @close="isShowModalEmail = false">
			<div slot="header"><h3>Email</h3></div>
			<div slot="body" class="text-center">
				<h4 class="modal-title">
				How to Integrate
				</h4>
				<div class="integration-warning">
					Untuk memastikan anda selalu mendapat pemberitahuan tentang setiap pemesanan, silahkan masukan email pada kolom input dibawah ini.<br>
					Silahkan ikuti tutorial <a href="https://help.ostock.id/id/6369646-how-to-integration" target="_blank">https://help.ostock.id/id/6369646-how-to-integration</a> untuk informasi lebih lengkap.<br>
				</div>
				<!-- <a class="modal-title h4" href="https://help.ostock.id" target="_blank">How to Integrate</a> -->
				<!-- <div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/VCVe2pgA6pc?rel=0"></iframe>
				</div> -->
				<div class="integration-actions mt-3">
					<div class="input-group">
						<input type="text" class="input form-control" placeholder="Email Address" v-model="email">
						<div class="input-group-prepend">
							<button
								type="button"
								class="input-group-text btn btn-primary"
								:disabled="email.length === 0"
								:class="{ 'is-loading': isAddingEmail }"
								@click="addEmail">Integrate
							</button>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalEmail = false">{{ $t('Close') }}</button>
			</div>
		</modal>
	</div>

	<notifications group="notification" position="bottom right" />
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import integrationApi from '../api/integration';

export default {
	name: 'settingsNotification',
	components: {
		Modal,
		IntegrationAccounts,
	},
	data() {
		return {
			isShowModalSlack: false,
			isShowModalEmail: false,
			email: '',
			isAddingEmail: false,
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			removeAccount: 'settings/removeAccount',
		}),
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = (response) => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addSlack(code) {
			const params = { code: code };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}

				this.$notify({
					group: 'notification',
					title: 'Notification',
					text: 'Successfully Connected to Slack',
					type: 'success',
				});
			};
			integrationApi.addSlack(params, callback);
		},
		checkCode() {
			const urlString = window.location.href;
			const url = new URL(urlString);
			const name = url.searchParams.get('name');
			const code = url.searchParams.get('code');
			if (name !== '' && code !== '') {
				if (name === 'slack') {
					this.addSlack(code);
				}
			}
		},
		addEmail() {
			this.isAddingEmail = true;
			const email = this.email;

			if (this.emailValidation(email)) {
				const params = { email };
				const callback = (response) => {
					const account = response.data;
					if (account !== '') {
						this.addAccount(account);
					}
					this.isAddingEmail = false;
					this.isShowModalEmail = false;

					this.$notify({
						group: 'notification',
						title: 'Notification',
						text: 'Successfully Added an Email',
						type: 'success',
					});
				};
				integrationApi.addEmail(params, callback);
			} else {
				this.isAddingEmail = false;
				this.$notify({
					group: 'notification',
					title: 'Notification',
					text: 'Invalid email format',
					type: 'error',
				});
			}
		},
		emailValidation(email) {
			var filter = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
			if (filter.test(email)) {
				return true;
			} else {
				return false;
			}
		},
	},
	computed: {
		...mapGetters({
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		slackAccounts() {
			return this.accounts.filter(account => account.name === 'slack');
		},
		emailAccounts() {
			return this.accounts.filter(account => account.name === 'email');
		},
		slackUrl() {
			const endpoint = 'https://slack.com/oauth/authorize';
			const scope = 'incoming-webhook';
			const clientId = '289640479333.361607201042';
			const appUrl = `${location.protocol}//${location.host}`;
			const redirectUri = `${appUrl}/settings/notification/callback/slack`;
			const url = `${endpoint}?scope=${scope}&client_id=${clientId}&redirect_uri=${redirectUri}`;
			return url;
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts();
		}
		this.checkCode();
	},
};
</script>
